'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _chemist = require('chemist');

var _flourish = require('./flourish');

var _flourish2 = _interopRequireDefault(_flourish);

var _painters = require('./painters');

var _painters2 = _interopRequireDefault(_painters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ColorSwatch = (_dec = (0, _chemist.configurable)(), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(ColorSwatch, _React$Component);

  function ColorSwatch() {
    (0, _classCallCheck3.default)(this, ColorSwatch);
    return (0, _possibleConstructorReturn3.default)(this, (ColorSwatch.__proto__ || (0, _getPrototypeOf2.default)(ColorSwatch)).apply(this, arguments));
  }

  (0, _createClass3.default)(ColorSwatch, [{
    key: 'render',
    value: function render() {
      var config = this.props.config;


      if (config.theme === 'painters') {
        return _react2.default.createElement(_painters2.default, this.props);
      }

      return _react2.default.createElement(_flourish2.default, this.props);
    }
  }]);
  return ColorSwatch;
}(_react2.default.Component)) || _class);
exports.default = ColorSwatch;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/ColorSwatch/index.js
// module id = 581
// module chunks = 0